<div class="game-details-card" [attr.aria-busy]="saving">
  <div class="game-details-card__overlay" *ngIf="saving">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div class="video-source-banner" *ngFor="let source of game.videoSources">
    <mat-icon class="video-source-banner__icon" aria-hidden="true"
      >video_settings</mat-icon
    >
    <div class="video-source-banner__content">
      <ng-template #summary>
        <span>
          Video source from tenant {{ source.tenant
          }}<ng-container *ngIf="teamLabel(source)"
            >&nbsp;({{ teamLabel(source) }})</ng-container
          >: <strong>{{ sourceName(source) }}</strong>
          <span
            class="video-source-banner__unselected"
            *ngIf="!source.selected"
            >&nbsp;— not explicitly picked for this game</span
          >
        </span>
      </ng-template>

      <button
        *ngIf="hasDetails(source); else summaryOnly"
        type="button"
        class="video-source-banner__summary"
        [attr.aria-expanded]="isExpanded(source)"
        [attr.aria-controls]="detailsId(source)"
        (click)="toggleSource(source)"
      >
        <mat-icon class="video-source-banner__chevron" aria-hidden="true">{{
          isExpanded(source) ? 'expand_less' : 'expand_more'
        }}</mat-icon>
        <ng-container *ngTemplateOutlet="summary"></ng-container>
      </button>
      <ng-template #summaryOnly>
        <span class="video-source-banner__summary">
          <ng-container *ngTemplateOutlet="summary"></ng-container>
        </span>
      </ng-template>

      <!-- Rendered whenever the button is, so aria-controls always resolves. -->
      <div
        class="video-source-banner__details"
        [id]="detailsId(source)"
        *ngIf="hasDetails(source)"
        [hidden]="!isExpanded(source)"
      >
        <div *ngIf="source.loginUrl">
          Login page:
          <a
            [href]="source.loginUrl"
            target="_blank"
            rel="noopener noreferrer"
            >{{ source.loginUrl }}</a
          >
        </div>
        <div *ngIf="showsCredentials(source)">
          Credentials:
          <a
            *ngIf="source.secretUrl; else credentialsText"
            [href]="source.secretUrl"
            target="_blank"
            rel="noopener noreferrer"
            >AWS Secrets Manager</a
          >
          <ng-template #credentialsText>{{
            credentialsLabel(source)
          }}</ng-template>
        </div>
        <div *ngIf="source.notes">Notes: {{ source.notes }}</div>
      </div>
    </div>
  </div>

  <div class="video-source-warning" *ngIf="game.videoSourcesUnavailable">
    <mat-icon class="video-source-warning__icon" aria-hidden="true"
      >error_outline</mat-icon
    >
    <span>
      Couldn't check which video source the customer provides. Refresh to try
      again.
    </span>
  </div>

  <table>
    <tr>
      <td class="col-sm-1">Camera</td>
      <td class="col-sm-1">Variant</td>
      <td class="col-sm-1 col-offset">Offset</td>
      <td class="col-sm-1 col-format">Format</td>
      <td class="col-sm-1">Status</td>
      <td class="col-sm-4">Video URL</td>
      <td class="col-sm-3"></td>
    </tr>
    <tr
      *ngFor="
        let video of game.videos;
        index as index;
        first as first;
        last as last
      "
    >
      <td class="col-sm-1">
        <select
          class="form-control"
          [(ngModel)]="video.cameraAngle"
          (ngModelChange)="onDetailsChange()"
          [ngModelOptions]="{ standalone: true }"
          required
          [class.is-invalid]="video.cameraAngle === null"
        >
          <option [ngValue]="null">Select Camera Angle</option>
          <option *ngFor="let camera of cameras" [ngValue]="camera[1]">{{
            displayName(camera[0]) | titlecase
          }}</option>
        </select>
        <div class="invalid-feedback">Please select a camera angle.</div>
      </td>
      <td class="col-sm-1">
        <select
          class="form-control"
          [(ngModel)]="video.variant"
          (ngModelChange)="onDetailsChange()"
          [ngModelOptions]="{ standalone: true }"
        >
          <option [ngValue]="null">Select Variant</option>
          <option *ngFor="let variant of variants" [ngValue]="variant">{{
            variant
          }}</option>
        </select>
      </td>
      <td class="col-sm-1 col-offset">
        <input
          type="number"
          class="form-control"
          [(ngModel)]="video.offset"
          (ngModelChange)="onDetailsChange()"
          [ngModelOptions]="{ standalone: true }"
        />
      </td>
      <td class="col-sm-1 col-format">
        <select
          class="form-control"
          [(ngModel)]="video.format"
          (ngModelChange)="onDetailsChange()"
          [ngModelOptions]="{ standalone: true }"
        >
          <option [value]="null"></option>
          <option value="mp4">MP4</option>
          <option value="hls">HLS</option>
        </select>
      </td>
      <td class="col-sm-1">
        <select
          class="form-control"
          style="width: 150px; display: inline-block; margin-left: 8px"
          [(ngModel)]="video.downloadStatus"
          (ngModelChange)="onDetailsChange()"
          [ngModelOptions]="{ standalone: true }"
        >
          <option ngValue="new">New</option>
          <option ngValue="in_progress">Archive In Progress</option>
          <option ngValue="complete">Archive Complete</option>
          <option ngValue="error">Archive Failed</option>
        </select>
      </td>
      <td class="col-sm-4">
        <input
          type="text"
          id="videoUrl"
          name="videoUrl"
          class="form-control"
          placeholder="https://..."
          [(ngModel)]="video.url"
          (ngModelChange)="onVideoUrlChange(video)"
          [ngModelOptions]="{ standalone: true }"
        />
      </td>
      <td class="col-sm-3" style="margin-top: 26px">
        <div style="display: flex">
          <button
            class="archive-button"
            mat-button
            (click)="downloadVideo.emit(video)"
            [disabled]="!videoDownloadAvailable(video)"
          >
            Archive...</button
          >

          <button
            class="remove-video-button"
            mat-icon-button
            type="button"
            (click)="onRemoveVideo(video)"
            ><mat-icon>remove_circle_outline</mat-icon>
          </button>
          <button
            mat-icon-button
            class="add-video-button"
            (click)="onAddVideo(index + 1)"
          >
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </div>
      </td>
    </tr>
  </table>

  <button
    mat-icon-button
    class="add-video-button"
    *ngIf="game.videos.length === 0"
    (click)="onAddVideo(0)"
  >
    <mat-icon>add_circle_outline</mat-icon>
  </button>

  <button
    mat-raised-button
    color="accent"
    (click)="uploadVideo.emit()"
    style="margin-left: 16px; width: 250px; margin-top: 16px"
  >
    Upload Video...</button
  >

  <button
    *ngIf="game.videos.length > 0"
    mat-button
    [disabled]="!canSyncLiveStreams || isSyncingLiveStreams"
    (click)="syncLiveStreams.emit()"
    matTooltip="Syncs the camera offsets once, now. Needs a live 'main' camera and at least one more live camera"
    style="margin-left: 16px; width: 250px; margin-top: 16px"
  >
    <mat-spinner
      *ngIf="isSyncingLiveStreams"
      diameter="16"
      style="
        display: inline-block;
        margin-right: 8px;
        vertical-align: text-bottom;
      "
    ></mat-spinner>
    Sync Live Streams</button
  >

  <div class="row mt-5">
    <div class="col-sm-12">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="time_synced"
          name="time_synced"
          [(ngModel)]="game.isCameraTimeSynchronized"
          (ngModelChange)="onDetailsChange()"
        />
        <label
          class="form-check-label"
          for="time_synced"
          matTooltip="Whether the timing of all cameras has been synced using offset adjustment"
          >Time Synced</label
        >
      </div>
    </div>

    <div class="col-sm-12 mt-3">
      <app-live-stream-selection
        (liveStreamAdded)="onLiveStreamAdded($event)"
      ></app-live-stream-selection>
    </div>
  </div>
</div>
